export const USER = {
  firstName: "Jeel",
  lastName: "Rupareliya",
  displayName: "Jeel Rupareliya",
  username: "jeelislive",
  gender: "male",
  bio: "Hustler",
  flipSentences: [
    "Microservices Architect",
    "Kafka & BullMQ Expert",
    "Production Debug Specialist",
    "Scalable Backend Systems",
  ],
  address: "Gandhinagar, India",
  phoneNumber: "KzkxLTYzNTUyOTEzNTY=", // base64 encoded: +91-6355291356
  email: "amVlbHJ1cGFyZWxpeWEyNTVAZ21haWwuY29t", // base64 encoded: jeelrupareliya255@gmail.com
  website: "https://www.rjisalive.tech/", // Replace with your portfolio site
  otherWebsites: [
    "https://github.com/jeelislive",
    "https://linkedin.com/in/jeelislive",
    "https://leetcode.com/Jeel404",
    "https://stackoverflow.com/users/28486945/jeel-rupareliya",
    "https://www.geeksforgeeks.org/user/jeelrupar536h/",
    "https://medium.com/@jeelrupareliya255",
  ],
  jobTitle: "Backend Engineer",
  jobs: [
    {
      title: "Backend Engineer",
      company: "Saleshandy",
      website: "https://saleshandy.com/",
    },
  ],
  about: `

Hello! I'm Jeel Rupareliya, a Backend Engineer specializing in microservices, Kafka, and scalable system architecture. I'm currently pursuing my Bachelor of Engineering in IT at Gujarat Technological University, with extensive production experience in backend development and system optimization.

My expertise lies in building robust backend systems using NestJS, Node.js, and event-driven architectures with Kafka. I've hands-on experience with production-level debugging, monitoring systems with Grafana, and optimizing database queries for performance. At Saleshandy, I work with scalable microservices handling async workflows with BullMQ + Redis and event-driven processing with Kafka.

I'm passionate about open-source contributions with 43 repositories and 850+ commits in the last year. I've contributed to projects like Firecrawl (TypeScript utilities) and Ivy Framework (frontend performance optimization). My problem-solving skills are demonstrated through 250+ DSA problems on LeetCode and GeeksforGeeks.

Beyond backend development, I leverage AI tools like Cursor, Gemini, and Claude Code to enhance development workflows. I believe in building systems that are not just functional, but scalable, maintainable, and production-ready.

Let's connect and build robust backend solutions that scale!
`,
  avatar:
    "https://res.cloudinary.com/dupv4u12a/image/upload/v1756060223/59065446-2926-495d-9b72-9eef077d286f.jpg", // Replace with updated image if needed
  ogImage:
    "https://res.cloudinary.com/dupv4u12a/image/upload/v1756060223/59065446-2926-495d-9b72-9eef077d286f.jpg",
  keywords:
    "jeel, jeelrupareliya, jeelislive, backend, microservices, kafka, nestjs, nodejs, typescript, javascript, portfolio",
  dateCreated: "2025-07-28",
};
